const ENV_OPENAI_KEY = process.env.REACT_APP_OPENAI_API_KEY?.trim();

/** Session input key, falling back to REACT_APP_OPENAI_API_KEY when unset. */
export function resolveOpenAiKey(inputKey?: string): string | undefined {
  const trimmed = inputKey?.trim();
  if (trimmed) return trimmed;
  return ENV_OPENAI_KEY || undefined;
}

export function hasOpenAiKey(inputKey?: string): boolean {
  return Boolean(resolveOpenAiKey(inputKey));
}

export function hasEnvOpenAiKey(): boolean {
  return Boolean(ENV_OPENAI_KEY);
}
